document.addEventListener('DOMContentLoaded', async () => {

    const qualifyingVariants = [
        43677846044926,
        43677845422334
    ];

    const giftVariant = 48666726367486;

    const cart = await fetch('/cart.js').then(r => r.json());

    let hasQualifying = false;
    let giftItem = null;

    cart.items.forEach(item => {

        if (qualifyingVariants.includes(item.variant_id)) {
            hasQualifying = true;
        }

        if (item.variant_id == giftVariant) {
            giftItem = item;
        }

    });

    // No qualifying product
    if (!hasQualifying && giftItem) {

        console.log("Removing Free Gift");

        await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type':'application/json'
            },
            body: JSON.stringify({
                id: giftItem.key,
                quantity:0
            })
        });

        location.reload();

    }

});